const state = {
  credits : [],
  errors: null
}

export default state